import { CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { router } from './router';
import { queryClient } from './services/queryClient';

const App: React.FC = () => (
  <AuthProvider>
    <SnackbarProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  </AuthProvider>
);

export default App;
